<div class="container">
    <div class="row justify-content-center" *ngIf="SecretItems.Client_secret">
        <div class="col-xl-4 col-lg-4 col-12 text-center">
            <div class="box-key text-start ">
                <div class="col-12 mb-3">
                    <p>Client ID</p>
                    <div class="box-key-api  input-icon-end m-action">
                        <input type="text" class="form-control" disabled [(ngModel)]="SecretItems.Client_id">
                        <span class="material-symbols-outlined" (click)="copyText(SecretItems.Client_id)">
                            content_copy
                        </span>
                    </div>
                </div>
                <div class="col-12">
                    <p>Client Secret</p>
                    <div class="box-key-api  input-icon-end m-action">
                        <input type="text" class="form-control" disabled [(ngModel)]="SecretItems.Client_secret">
                        <span class="material-symbols-outlined" (click)="copyText(SecretItems.Client_secret)">
                            content_copy
                        </span>
                    </div>
                </div>
                <div class="col-12">
                    <br>
                    <button class="btn btn-primary" (click)="changeSecret(SecretItems)">
                        Change Secret Key
                    </button>
                </div>
            </div>
            <br><br>
        </div>
    </div>
    <br>
    <br>
    <div class="row justify-content-center" *ngIf="!SecretItems.Client_secret">
        <div class="col-xl-4 col-lg-4 col-12 text-center">
            <div class="box-key text-start ">
                <div class="col-12">
                    <button class="btn btn-primary btn-create-key" (click)="createSecret()">
                        สร้าง Secret Key
                    </button>
                </div>
            </div>
            <br><br>
        </div>
    </div>
    <br>
    <br>

</div>